
import Confirm from './confirm';

function confirm(props) {
  return new Confirm(props);
}

export default confirm;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/confirm/index.js
// module id = 551
// module chunks = 9